export default __webpack_public_path__ + "static/media/DSC_7407.e70a95dc.jpg";